import useAuthStore from '~/store/auth'

/**
 * Plugin that refreshes the user token on the server side (if user token exists) on first load.
 */
export default defineNuxtPlugin(async (nuxtApp) => {
	if (!import.meta.server) {
		return
	}

	const token = useCookie('token')

	if (!token.value) {
		return
	}

	const authStore = useAuthStore()

	try {
		await authStore.refresh()
	} catch (e) {
		token.value = null
	}
})
